import React, { useState, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import ChatInputTextarea from './chat-input-textarea';
import ChatAttachmentPreview from './chat-attachment-preview';
import { ChatInputSC } from './chat-window.styled';
import { memberApi } from '../../lib/api';
import { showNotification } from '../../helpers/notification-helper';
import { TAttachment } from '../../types/attachments';

type TProps = {
  onSubmit(message: string, attachment?: TAttachment): void;
  disabledSubmit?: boolean;
};

const ChatInput: React.FC<TProps> = ({ onSubmit, disabledSubmit }) => {
  const [message, setMessage] = useState('');
  const [rows, setRows] = useState(1);
  const [attachmentPreview, setAttachmentPreview] = useState('');
  const [attachmentType, setAttachmentType] = useState('');
  const [attachmentName, setAttachmentName] = useState('');

  const fileInputRef: React.Ref<any> = useRef();

  const onAttachmentChange = () => {
    setAttachmentName(fileInputRef.current.files[0]?.name);
    setAttachmentType(fileInputRef.current.files[0]?.type);
    setAttachmentPreview(URL.createObjectURL(fileInputRef.current.files[0]));
  };

  const onAttachmentRemove = () => {
    setAttachmentPreview('');
    setAttachmentType('');
    setAttachmentName('');
    fileInputRef.current.value = '';
  };

  const sendAttachment = () => {
    const file = fileInputRef.current.files[0];

    memberApi
      .postAttachment(file)
      .then((res: any) => {
        const id = res.data.data.id;
        const attachment = {
          id,
          type: file.type,
          size: file.size,
          name: file.name,
        };
        onSubmit(message, attachment);
        reset();
      })
      .catch((err) => {
        console.log(err);
        console.log(err?.data);
        showNotification({
          type: 'ERROR',
          title: <FormattedMessage id="server_error.send_attachment_failed" />,
          copy: '',
        });
      });
  };

  const reset = () => {
    setMessage('');
    setRows(1);
    onAttachmentRemove();
  };

  const onFormSubmit = (e?: any) => {
    e?.preventDefault();

    if (attachmentPreview) {
      sendAttachment();
    } else {
      onSubmit(message);
      reset();
    }
  };

  return (
    <ChatInputSC onSubmit={onFormSubmit}>
      <div className="ci-input">
        <ChatInputTextarea
          rows={rows}
          message={message}
          setMessage={setMessage}
          setRows={setRows}
          onSubmit={onFormSubmit}
          disabled={!!disabledSubmit}
        />
        <ChatAttachmentPreview
          preview={attachmentPreview}
          type={attachmentType}
          name={attachmentName}
          onRemove={onAttachmentRemove}
        />
      </div>
      <div className="ci-controls">
        <label className="ci-button ci-button-grey ci-attachment">
          <img src={require('../../assets/svg/icon-paperclip.svg').default} alt="Attachment" />
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*,application/pdf"
            onChange={onAttachmentChange}
            disabled={disabledSubmit}
          />
        </label>
        <div className="ci-separator">&nbsp;</div>
        <button className="ci-button ci-send" type="submit" disabled={disabledSubmit}>
          <img src={require('../../assets/svg/icon-send.svg').default} alt="Send" />
        </button>
      </div>
    </ChatInputSC>
  );
};

export default ChatInput;
